import React, { Component } from "react";

type OwnProps = {
  disabled: boolean,
  icon: JSX.Element,
  title: string,
  gradient: string, // 0/1 is white, 1/1 is pink, 60/60 is green
  path: string,
  handleClick: () => void,
};

type Props = OwnProps;

class GradientButton extends Component {
  props: Props;
  state: State = {};

  constructor(props: Props) {
    super(props);
  }

  calculatedGradient = () => {
    if (this.props.disabled) return "#ddd";
    const [num, den] = (this.props.gradient || "1/1").split("/");
    const ratio = (+num - 1) / +den;
    return `rgb(${235 - 60 * ratio}, ${229 - 48 * ratio}, ${229 - 48 * ratio})`;
  };

  renderClickable = (children) => {
    if (this.props.path) return <a href={this.props.path}>{children}</a>;
    return children;
  };

  render() {
    return (
      <div
        className="gradient-button-container"
        style={{ background: this.calculatedGradient() }}
        onClick={!this.props.disabled && this.props.handleClick}
      >
        {this.renderClickable(
          <div className="gradient-button pointer">
            {!!this.props.icon && (
              <span style={{ marginRight: 10, marginBottom: -5.5 }}>
                {this.props.icon}
              </span>
            )}
            <span>{this.props.title && this.props.title.toUpperCase()}</span>
          </div>
        )}
      </div>
    );
  }
}

export default GradientButton;



// WEBPACK FOOTER //
// ./src/components/input/GradientButton.jsx